import { baseQuery } from '../baseQuery';

type DeleteTechnicianRecurringAvailabilityPayload = {
  technicianId: number;
  recurringAvailabilityId: number;
};

export const deleteTechnicianRecurringAvailability = async (payload: DeleteTechnicianRecurringAvailabilityPayload) => {
  const { technicianId, recurringAvailabilityId } = payload;
  const { data } = await baseQuery(`technicians/${technicianId}/recurring-availabilities/${recurringAvailabilityId}`, {
    type: 'DELETE',
  });

  return data;
};
